import Image from 'next/image';
import ReactMarkdown from 'react-markdown';
import { TeamMemberHeadingStyles } from '../../styles/components/team-members';

export interface ITeamMemberHeadingProps {
  fullname: string;
  jobTitle: string;
  biography: string;
  socialMediaIcons: { iconUrl: string; link: string }[];
  imageUrl: string;
}

const TeamMemberHeading = (props: ITeamMemberHeadingProps) => {
  return (
    <div className={TeamMemberHeadingStyles['team-member-heading']}>
      <div className={TeamMemberHeadingStyles['team-member-heading-content']}>
        <div>
          <h1>{props.fullname}</h1>
          <p
            className={
              TeamMemberHeadingStyles['team-member-heading-content-job-title']
            }>
            {props.jobTitle}
          </p>
        </div>
        {props.socialMediaIcons && props.socialMediaIcons.length > 0 && (
          <div
            className={
              TeamMemberHeadingStyles[
                'team-member-heading-content-social-media'
              ]
            }>
            {props.socialMediaIcons.map((icon, index) => (
              <a key={index} href={icon.link} target="_blank">
                <Image
                  src={icon.iconUrl}
                  alt={`Social media icon ${index}`}
                  width={24}
                  height={24}
                />
              </a>
            ))}
          </div>
        )}
        <ReactMarkdown
          className={
            TeamMemberHeadingStyles['team-member-heading-content-biography']
          }>
          {props.biography}
        </ReactMarkdown>
      </div>
      <div className={TeamMemberHeadingStyles['team-member-heading-image']}>
        <Image
          src={props.imageUrl}
          alt={`${props.fullname} image`}
          height={400}
          width={400}
        />
      </div>
    </div>
  );
};

export default TeamMemberHeading;
